"use client";

import { OffersOffer } from '@/services/dataTypes';
import React, { useState } from 'react';
import { filterOfferBanners, getBannerDimensions } from '@/constants/hooks';
import Banner from './Banner';

interface Props {
    bannerResponse: OffersOffer[];
    domain: string;
    mer_slug: string;
    slug_type: string;
}

const VerticalPromotionOfferBanner = ({ bannerResponse, domain, mer_slug, slug_type }: Props) => {
    const filtered = filterOfferBanners(bannerResponse, 50, 2000, 65, 2000);
    const [visibleCount, setVisibleCount] = useState(6);
    const [loading, setLoading] = useState(false);

    const handleShowMore = () => {
        setLoading(true);
        setTimeout(() => { setVisibleCount(p => p + 6); setLoading(false); }, 300);
    };

    if (!filtered?.length) return null;

    const displayedBanners = filtered.slice(0, visibleCount);
    const hasMore = visibleCount < filtered.length;

    return (
        <div
            style={{
                background: '#081C11',
                border: '1px solid rgba(122,252,32,0.12)',
            }}
        >
            {/* Header */}
            <div className="flex items-center gap-2 px-4 py-3" style={{ borderBottom: '1px solid rgba(122,252,32,0.08)' }}>
                <div className="h-px w-5 bg-gradient-to-r from-[#7AFC20] to-transparent" />
                <span className="text-[10px] font-black uppercase tracking-[0.25em]" style={{ color: '#F5F5DC' }}>
                    Banner Offers
                </span>
            </div>

            {/* Banners */}
            <div className="p-4 flex flex-col gap-3">
                {displayedBanners.map((offer_data, i) => {
                    const dimension = getBannerDimensions(offer_data);
                    return (
                        <div key={i} className="overflow-hidden transition-transform duration-300 hover:-translate-y-0.5"
                            style={{ border: '1px solid rgba(122,252,32,0.08)' }}>
                            <Banner data={offer_data} height={dimension?.height}
                                mer_slug={mer_slug} slug_type={slug_type}
                                domain={domain} width={dimension?.width} />
                        </div>
                    );
                })}
            </div>

            {/* Show more */}
            {hasMore && (
                <div className="px-4 pb-4">
                    <button
                        onClick={handleShowMore}
                        disabled={loading}
                        className="w-full flex items-center justify-center gap-2 py-2.5 text-[10px] font-black uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 disabled:opacity-50"
                        style={{
                            background: '#7AFC20',
                            color: '#081C11',
                            clipPath: 'polygon(0 0, calc(100% - 7px) 0, 100% 7px, 100% 100%, 7px 100%, 0 calc(100% - 7px))',
                        }}
                    >
                        {loading
                            ? <span className="w-3.5 h-3.5 border-2 border-[#081C11] border-t-transparent rounded-full animate-spin" />
                            : 'Show More'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default VerticalPromotionOfferBanner;
